import BreadcrumbItem from 'Components/Atoms/BreadcrumbItem/BreadcrumbItem';
import { Container } from 'Components/Atoms/ContainerDeprecated/Container';
import Loader from 'Components/Atoms/Loader/Loader';
import Accordion from 'Components/Molecules/Accordion/Accordion';
import Breadcrumbs from 'Components/Molecules/Breadcrumbs/Breadcrumbs';
import PageHeader from 'Components/Organisms/PageHeader/PageHeader';
import EntityModulesSettings from 'Components/Organisms/EntityModulesSettings/EntityModulesSettings';
import EntityRelationSettings from 'Components/Organisms/EntityRelationSettings/EntityRelationSettings';
import GeneralSettings from 'Components/Organisms/GeneralSettings/GeneralSettings';
import PageTemplate from 'Components/Templates/Page/Page/PageTemplate';
import { useEffect } from 'react';
import { Helmet } from 'react-helmet-async';
import { connect } from 'react-redux';
import { useParams } from 'react-router-dom';
import { getEntityDisplayValue } from 'Services/helpers';
import { ROUTE } from 'Services/Route/Route.types';
import { getAllDatasets, getAllLayouts } from 'Store/FieldManagement/Selectors';
import { fetchEntities } from 'Store/Settings/Entities/Actions';
import { getEntitiesById, getEntityIds } from 'Store/Settings/Entities/Selectors';

const EntitiesPageOld = ({entities, entityById, ...props}: any) => {
    const { entity_id } = useParams();

    useEffect(() => {
        props.fetchEntities();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <PageTemplate>
            <Helmet>
                <title>Entiteiten - Growing People B.V.</title>
            </Helmet>

            <Container>
                <PageHeader
                    breadcrumbs={
                        <Breadcrumbs>
                            <BreadcrumbItem path={ROUTE.DASHBOARD}>Home</BreadcrumbItem>
                            <BreadcrumbItem path={ROUTE.SETTINGS}>Instellingen</BreadcrumbItem>
                            <BreadcrumbItem>Entiteiten</BreadcrumbItem>
                        </Breadcrumbs>
                    }
                />

                { !Array.isArray(entities) && <Loader description='Entiteiten ophalen...' /> }

                {
                    Array.isArray(entities) &&
                    entities?.filter(i => i === entity_id)?.sort((a, b) => (getEntityDisplayValue(entityById[a]?.name) > getEntityDisplayValue(entityById[b]?.name)) ? 1 : ((getEntityDisplayValue(entityById[b]?.name) > getEntityDisplayValue(entityById[a]?.name)) ? -1 : 0))
                    .map((id, idx: number) => {
                        const item = entityById[id];

                        return <Accordion title={getEntityDisplayValue(item?.name)} key={id} isOpen={idx == 0}>
                            <GeneralSettings id={item?.id} /><br />
                            <EntityRelationSettings id={item?.id} /><br />
                            <EntityModulesSettings id={item?.id} />
                        </Accordion>
                    })
                }
            </Container>
        </PageTemplate>
    )
}

export default connect(
    (state: any) => ({
        layouts: getAllLayouts(state),
        datasets: getAllDatasets(state),
        entities: getEntityIds(state),
        entityById: getEntitiesById(state)
    }), {
        fetchEntities
    }
)(EntitiesPageOld);